import { render, staticRenderFns } from "./FormPasswordRecoveryComponent.vue?vue&type=template&id=c6a25200&scoped=true&"
import script from "./FormPasswordRecoveryComponent.vue?vue&type=script&lang=js&"
export * from "./FormPasswordRecoveryComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormPasswordRecoveryComponent.vue?vue&type=style&index=0&id=c6a25200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a25200",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
